import { Button } from '@hub/shared'
import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import './campaign-card-link.component.scoped.scss'

interface Props extends PropsWithChildren<React.HTMLAttributes<HTMLDivElement>> {
  primaryColor?: string
  secondaryColor?: string
  orientation?: 'horizontal' | 'vertical'
  link: string
}

export default ({
  orientation = 'horizontal',
  primaryColor = 'var(--primary_color)',
  secondaryColor = 'var(--secondary_color)',
  link = '',
  children,
  id,
}: Props) => {
  const [t] = useTranslation('campaignCardLink')
  const timestamp = `random-id-${(1 + Date.now() + Math.random()).toString().replace('.', '')}`

  return (
    <Link
      id={id ? id : timestamp}
      to={link.replace('campaigns/', '')}
      key={id}
      style={{ backgroundColor: primaryColor, border: `2px solid ${primaryColor}` }}
      className={`all-campaigns-card ${orientation}`}
    >
      <i className="fa-regular fa-rectangle-vertical-history" style={{ color: secondaryColor, fontSize: '4rem' }}></i>
      <div className="wrapper-text-area">
        <div
          style={{ color: secondaryColor }}
          className={`inside-text-area ${orientation === 'horizontal' && link !== 'campaigns/finished' ? 'mb-2' : ''}`}
        >
          {children}
        </div>
        <Button
          size="sm"
          className="py-0"
          borderColor={secondaryColor}
          color={secondaryColor}
          textColor={primaryColor}
          rounded
          style={{ lineHeight: link === 'campaigns/finished' ? '1.15' : '1.5' }}
        >
          <span className="small">{t('seeAll')}</span>
        </Button>
      </div>
    </Link>
  )
}
